import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  shareEventButton: {
    width: theme.spacing(10.5),
    height: theme.spacing(4),
    [theme.breakpoints.down("lg")]: {
      width: theme.spacing(4),
    },
    marginRight: theme.spacing(1),
    whiteSpace: "nowrap",
    border: `1px solid ${theme.palette.text.primary}`,
  },
  shareText: {
    color: theme.palette.text.primary,
    "&:hover": {
      color: theme.palette.text.primary,
    },
  },
}));
